import { render, staticRenderFns } from "./jxOrderList.vue?vue&type=template&id=31c2ee02&scoped=true"
import script from "./jxOrderList.vue?vue&type=script&lang=js"
export * from "./jxOrderList.vue?vue&type=script&lang=js"
import style0 from "./jxOrderList.vue?vue&type=style&index=0&id=31c2ee02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c2ee02",
  null
  
)

export default component.exports